import { FC } from 'react'

type Props = {
  on: boolean
  onChange: (next: boolean) => void
  label: string
  disabled?: boolean
}

/** Minimal Tailwind on/off switch matching the panel's teal accent. */
const Toggle: FC<Props> = ({ on, onChange, label, disabled = false }) => {
  return (
    <button
      type='button'
      role='switch'
      aria-checked={on}
      disabled={disabled}
      onClick={() => onChange(!on)}
      className={`flex w-full items-center justify-between py-1 ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      <span className='text-sm font-medium text-white'>{label}</span>
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          on ? 'bg-teal-400' : 'bg-gray-500'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            on ? 'translate-x-4' : 'translate-x-1'
          }`}
        />
      </span>
    </button>
  )
}

export default Toggle
